import DialogContent from "@mui/material/DialogContent";
import DialogActions from "@mui/material/DialogActions";
import React, { useCallback, useState } from "react";
import { Button, FormControl, FormControlLabel, Switch } from "@mui/material";
import { useDialog } from "../Upsell/modernTS/JUI/Dialogs";
import axios from "axios";
import { toast } from "react-toastify";
import { BlockUserInput } from "@jamezz/react-components";

export default function useAskOptimizeImagesDialog() {
  const { createDialog, closeDialog } = useDialog();
  const { blockingStarted, blockingStopped } = BlockUserInput.useBlockUserInput();
  return useCallback(
    (selectedIds: number[]) => {
      return new Promise<undefined>((resolve, reject) => {
        createDialog({
          name: "useAskOptimizeImagesDialog",
          maxWidth: "lg",
          children: (
            <AskOptimizeImages
              onCancel={() => {
                closeDialog("useAskOptimizeImagesDialog");
                reject();
              }}
              onOk={(crop) => {
                blockingStarted();
                axios
                  .post("core/producten/optimizeimages", { ids: selectedIds, crop })
                  .then((response) => {
                    const aantal = response.data.data.optimized;
                    toast.success(aantal + " items queued for optimalisation");
                    closeDialog("useAskOptimizeImagesDialog");
                  })
                  .finally(() => {
                    blockingStopped();
                    resolve();
                  });
              }}
            />
          ),
        });
      });
    },
    [createDialog, blockingStarted, closeDialog, blockingStopped]
  );
}

function AskOptimizeImages({ onOk, onCancel }: { onOk: (crop: boolean) => void; onCancel: () => void }) {
  const [crop, setCrop] = useState<boolean>(true);

  return (
    <>
      <DialogContent sx={{ maxWidth: 600, width: 1 }}>
        <FormControl>
          <FormControlLabel
            checked={crop}
            control={<Switch />}
            label={"Crop images"}
            onChange={(e) => setCrop(e.target.checked as boolean)}
          />
        </FormControl>
      </DialogContent>
      <DialogActions sx={{ gap: 5, justifyContent: "center" }}>
        <Button
          onClick={() => {
            onCancel();
          }}
          sx={{ maxWidth: 300, width: 1 }}
          variant={"contained"}
        >
          Cancel
        </Button>
        <Button onClick={() => onOk(crop)} sx={{ maxWidth: 300, width: 1 }} variant={"contained"}>
          Ok
        </Button>
      </DialogActions>
    </>
  );
}
